export class DocumentFilter {
  /**
   * Category filter radio form
   *
   * @protected
   */
  protected categoryFilterForm?: HTMLFormElement;

  /**
   * Hidden input field for filter category group
   *
   * @protected
   */
  protected filterCategoryGroupInput?: HTMLInputElement | null;

  /**
   * Hidden input field for filter category
   *
   * @protected
   */
  protected filterCategoryInput?: HTMLInputElement | null;

  /**
   * Wrapper with specific filter buttons
   *
   * @protected
   */
  protected categoryFilterItems?: NodeListOf<HTMLElement>;

  /**
   * Group filter buttons
   *
   * @protected
   */
  protected categoryFilterGroupButtons?: NodeListOf<HTMLButtonElement>;

  /**
   * Filter buttons in selected gorup
   *
   * @protected
   */
  protected categoryFilterButtons?: NodeListOf<HTMLButtonElement>;

  /**
   * Document filter options
   *
   * @protected
   */
  protected options: DocumentFilterOptions;

  constructor(options = {}) {
    const defaults: DocumentFilterOptions = {
      categoryFilterFormId: 'form-documentshop-filter-categories',
      filterCategoryGroupInputId: 'filterCategoryGroup',
      filterCategoryInputId: 'filterCategory',
      modalFilterQuerySelectorId: 'js-modal-vrs-documentshop-filter',
      categoryFilterGroupButtonClass: 'vrs-documentshop__filter-category-group',
      categoryFilterGroupButtonActiveClass: 'active',
      categoryFilterButtonClass: 'vrs-documentshop__filter-category',
      categoryFilterWrapperClass: 'filter-toggle__target',
      categoryFilterWrapperActiveClass: 'filter-toggle__target-active',
    };

    this.options = {
      ...defaults,
      ...options,
    };

    this.categoryFilterForm = document.getElementById(`${this.options.categoryFilterFormId}`)! as HTMLFormElement;

    if (this.categoryFilterForm !== null) {
      this.initDocumentFilter();
    } else {
      // note: the js code runs on every page, so this isn't an accurate warning. Commented out to clean up console output on live...
      // console.warn('DocumentFilter could not be initialized.');
    }
  }

  protected initDocumentFilter(): void {
    this.categoryFilterGroupButtons = this.categoryFilterForm?.querySelectorAll(`.${this.options.categoryFilterGroupButtonClass}`);
    this.categoryFilterButtons = this.categoryFilterForm?.querySelectorAll(`.${this.options.categoryFilterButtonClass}`);
    this.categoryFilterItems = this.categoryFilterForm?.querySelectorAll(`.${this.options.categoryFilterWrapperClass}`);
    this.filterCategoryGroupInput = this.categoryFilterForm?.querySelector(`#${this.options.filterCategoryGroupInputId}`) as HTMLInputElement;
    this.filterCategoryInput = this.categoryFilterForm?.querySelector(`#${this.options.filterCategoryInputId}`) as HTMLInputElement;

    if (this.categoryFilterGroupButtons !== null && this.categoryFilterButtons !== null) {
      this.initCategoryFilterGroups();
      this.initCategoryFilter();
    } else {
      console.warn('DocumentFilter category filter could not be initialized.');
    }

    // openFilterModal
    const buttonOpenFilterModal = document.getElementsByClassName('js-button-open-filter-modal');
    for (let i = 0; i < buttonOpenFilterModal.length; i++) {
      buttonOpenFilterModal[i].addEventListener('click', event => {
        const filterModal = document.querySelector(`#${this.options.modalFilterQuerySelectorId}`)!;
        filterModal.classList.add('open');
      });
    }

    // closeFilterModal
    const buttonCloseFilterModal = document.getElementsByClassName('js-button-close-filter-modal');
    for (let i = 0; i < buttonCloseFilterModal.length; i++) {
      buttonCloseFilterModal[i].addEventListener('click', event => {
        const filterModal = document.querySelector(`#${this.options.modalFilterQuerySelectorId}`)!;
        filterModal.classList.remove('open');
      });
    }
  }

  protected initCategoryFilterGroups(): void {
    this.categoryFilterGroupButtons?.forEach(btn => {
      btn.addEventListener('click', event => this.onClickCategoryFilterGroup(event));
    });
  }

  protected initCategoryFilter(): void {
    this.categoryFilterButtons?.forEach(btn => {
      btn.addEventListener('click', event => this.onClickCategoryFilter(event));
    });
  }

  protected onClickCategoryFilterGroup(event): void {
    const buttonTarget = event.target.closest('button');
    const dataFilterGroup = buttonTarget.dataset.filterCategoryGroup;

    // update active class for filter groups
    this.categoryFilterGroupButtons?.forEach(btn => {
      btn.classList.remove(<string>this.options.categoryFilterGroupButtonActiveClass);
      btn.setAttribute('aria-selected', 'false');
    });
    buttonTarget.classList.add(<string>this.options.categoryFilterGroupButtonActiveClass);
    buttonTarget.setAttribute('aria-selected', 'true');

    this.categoryFilterItems?.forEach(el => {
      if (el.dataset.filterCategoryGroup === dataFilterGroup) {
        el.classList.add(<string>this.options.categoryFilterWrapperActiveClass);
      } else {
        el.classList.remove(<string>this.options.categoryFilterWrapperActiveClass);
      }

      // update hidden filter group input
      if (this.filterCategoryGroupInput) {
        this.filterCategoryGroupInput.value = dataFilterGroup;
      }
    });
  }

  protected onClickCategoryFilter(event): void {
    const buttonTarget = event.target.closest('button');
    const dataFilter = buttonTarget.dataset.filterCategory;

    // update hidden filter input
    if (this.filterCategoryInput) {
      this.filterCategoryInput.value = dataFilter;
    }

    this.categoryFilterForm?.submit();
  }
}

export interface DocumentFilterOptions {
  categoryFilterFormId?: string;
  filterCategoryGroupInputId?: string;
  filterCategoryInputId?: string;
  modalFilterQuerySelectorId?: string;
  categoryFilterGroupButtonClass?: string;
  categoryFilterGroupButtonActiveClass?: string;
  categoryFilterButtonClass?: string;
  categoryFilterWrapperClass?: string;
  categoryFilterWrapperActiveClass?: string;
}
